import store from "../store";
import * as utils from "../utils";
import * as types from "./constants";


export function selectItem(item, quantity) {
  const url = _getActionUrlFor('select-item');
  const data = {
    item,
    quantity
  };
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.UPDATE_SPONSORED_REGISTRY,
      sponsoredRegistry: response
    });
  }).fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function removeSelection(id) {
  const url = _getActionUrlFor('remove-selection');
  const data = {
    item: id
  }
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.UPDATE_SPONSORED_REGISTRY,
      sponsoredRegistry: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}


function _getActionUrlFor(actionStr) {
  return `/ajax/event/${window.evite_event.id}/sponsored-registry/${actionStr}/?gid=${window.guest_id}`;
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/sponsored-registry/actions.es6